import { useState } from "react";
import { X, Link2, Unlink } from "lucide-react";
import { PLATFORM_META } from "./platformMeta";

export function PlatformCards({ accounts, onConnect, onDisconnect }) {
  const [modal, setModal] = useState(null); // platform key
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const open = (p) => { setModal(p); setUsername(""); setPassword(""); };

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await onConnect(modal, username, password);
    setBusy(false);
    if (res?.ok !== false) setModal(null);
  };

  return (
    <>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="social-platform-cards">
        {accounts.map((a) => {
          const meta = PLATFORM_META[a.platform];
          return (
            <div key={a.platform} className={`border-2 p-5 flex flex-col gap-3 transition-colors ${a.connected ? "border-[#2C3539]/20 bg-white" : "border-dashed border-[#2C3539]/25 bg-[#F1F3F5]"}`} data-testid={`social-platform-${a.platform}`}>
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 inline-flex items-center justify-center text-white text-lg" style={{ background: meta.color }}>
                  <i className={meta.icon} />
                </span>
                {a.connected && <span className="text-[10px] font-bold tracking-[0.2em] uppercase text-green-700 bg-green-100 px-2 py-1">Linked</span>}
              </div>
              <div>
                <div className="font-display text-xl uppercase text-[#23282B]">{meta.name}</div>
                <div className="text-xs text-[#23282B]/60 truncate">{a.connected ? `@${a.username}` : "Not connected"}</div>
              </div>
              {a.connected ? (
                <button onClick={() => onDisconnect(a.platform)} data-testid={`social-disconnect-${a.platform}`} className="inline-flex items-center justify-center gap-2 text-xs font-bold tracking-[0.14em] uppercase border border-[#23282B]/25 hover:border-red-500 hover:text-red-600 px-3 py-2 transition-colors">
                  <Unlink size={13} /> Disconnect
                </button>
              ) : (
                <button onClick={() => open(a.platform)} data-testid={`social-connect-${a.platform}`} className="inline-flex items-center justify-center gap-2 text-xs font-bold tracking-[0.14em] uppercase bg-[#23282B] hover:bg-[#2F5F80] text-white px-3 py-2 transition-colors">
                  <Link2 size={13} /> Connect
                </button>
              )}
            </div>
          );
        })}
      </div>

      {modal && (
        <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center px-5" data-testid="social-connect-modal">
          <form onSubmit={submit} className="bg-white w-full max-w-md p-8 border-t-4" style={{ borderColor: PLATFORM_META[modal].color }}>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 inline-flex items-center justify-center text-white" style={{ background: PLATFORM_META[modal].color }}>
                  <i className={PLATFORM_META[modal].icon} />
                </span>
                <div className="font-display text-2xl uppercase text-[#23282B]">Link {PLATFORM_META[modal].name}</div>
              </div>
              <button type="button" onClick={() => setModal(null)} data-testid="social-modal-close" className="p-1 text-[#23282B]/60 hover:text-[#23282B]"><X size={20} /></button>
            </div>
            <div className="mt-4 bg-[#9CC4DB]/15 border-l-4 border-[#9CC4DB] px-3 py-2 text-xs text-[#23282B]/80">
              DEMO MODE — credentials are not stored or sent to any platform. This simulates the account link.
            </div>
            <label className="block mt-5">
              <span className="block text-xs tracking-[0.2em] font-bold uppercase text-[#23282B]/80 mb-2">Username / Email</span>
              <input data-testid="social-connect-username" required value={username} onChange={(e) => setUsername(e.target.value)} className="w-full border-2 border-[#23282B]/15 focus:border-[#2F5F80] focus:outline-none px-4 py-3" />
            </label>
            <label className="block mt-4">
              <span className="block text-xs tracking-[0.2em] font-bold uppercase text-[#23282B]/80 mb-2">Password</span>
              <input data-testid="social-connect-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border-2 border-[#23282B]/15 focus:border-[#2F5F80] focus:outline-none px-4 py-3" />
            </label>
            <button type="submit" disabled={busy} data-testid="social-connect-submit" className="mt-6 w-full bg-[#2F5F80] hover:bg-[#234B66] text-white text-sm font-bold tracking-[0.15em] uppercase py-3.5 transition-colors disabled:opacity-50">
              {busy ? "Linking…" : "Link Account"}
            </button>
          </form>
        </div>
      )}
    </>
  );
}
